import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchCountry'
})
export class SearchCountryPipe implements PipeTransform {

  transform(countries: any, searchText: string){
    if (!searchText) {
      return countries; // Return the original array if search text is empty
    }

    searchText = searchText.toLowerCase(); // Convert the search text to lowercase for case-insensitive comparison

    return countries.filter((countries: any) => countries.country_name.toLowerCase().includes(searchText));
  }

}
